import React from 'react'
import './style.styl'
import Clearbit from "./Icons/Clearbit"
import SIX_SENSE from "./Icons/SIX_SENSE"

const CompanyInfoProvider = ({ provider }) => {

  switch (provider) {
    case 'CLEARBIT':
      return <Provider icon={<Clearbit />}/>
    case 'SIX_SENSE':
      return <Provider icon={<SIX_SENSE />}/>
    default:
      return null
  }
}


const Provider = ({ icon }) => {
  return (
    <div className="company-info-provider">
      <span className="company-info-provider-msg">
        Powered by
      </span>
      {icon}
    </div>
  )
}


export default CompanyInfoProvider



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/CompanyInfo/CompanyInfoProvider/index.js